"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_EVENT_REGISTRATION = exports.MUTATE_SUPPRESSION = exports.REMOVE_TLW = exports.MUTATE_TLW = exports.UPDATE_APPLICATION_CREDENTIALS = exports.PROCESS_LEAVING_CREDENTIAL_APPLICATION_PAGE = exports.MUTATE_APPLICATION = exports.QUERY_ORGANIZATIONS_BY_NAME = exports.MUTATE_UPDATE_MARKETING_CONSENT = exports.QUERY_MARKETING_CONSENT = exports.QUERY_ORGANIZATION_BY_NAME_AND_ADDRESS = exports.QUERY_QUALIFICATION = exports.GET_APPLICATION_BY_ID = exports.MUTATE_ORGANIZATION = exports.MUTATE_REMOVE_EMPLOYMENT = exports.MUTATE_UPDATE_EMPLOYMENT_DATA_SHARING = exports.MUTATE_UPDATE_EMPLOYMENT = exports.MUTATE_EMPLOYMENT = exports.MUTATE_PROCESS_QUALIFICATION = exports.MUTATE_PERSON_ACCOUNT = exports.MUTATE_UPDATED_PASSWORD_MAIL = exports.MUTATE_TEMPORARY_PASSWORD_MAIL = exports.MUTATE_CPA_STATUS = exports.QUERY_SFMC_LINK = exports.QUERY_MY_PROFILE = exports.QUERY_CPA_STATUS = exports.GENERATE_TEMPORARY_PASSWORD = exports.CHANGE_PASSWORD_NOTIFICATION_EMAIL = exports.CHANGE_PASSWORD = exports.GET_USER_PLATFORM = exports.SEARCH_OKTA_USER = exports.FORGOT_PASSWORD = exports.RESOLVE_EMAIL = exports.CREATE_USER = exports.GET_PUB_KEY = exports.MUTATE_USER_FEEDBACK_BY_SURVEY = exports.MUTATE_USER_FEEDBACK_BY_CONTENT_ID = exports.QUERY_USER_FEEDBACK_BY_CONTENT_ID = exports.MUTATE_MARKETING_PREFERENCES = exports.QUERY_MARKETING_PREFERENCES = exports.QUERY_NET_FORUM_USER = exports.QUERY_USER_PROFILE = exports.QUERY_USER_BY_ID = exports.MUTATE_GOLDEN_RECORD_EMAIL = exports.MUTATE_GOLDEN_RECORD_SHORTCUTS = exports.MUTATE_GOLDEN_RECORD_CIMA_PREFERENCES = exports.MUTATE_GOLDEN_RECORD_PREFERENCES = exports.MUTATE_USER_STATE = exports.QUERY_USER_STATE = exports.QUERY_GOLDEN_RECORD = void 0;
exports.SEARCH_EMPLOYER = exports.GET_USER_SYLLABUS = exports.MUTATE_CURRENT_LEARNING_PATHWAY = exports.VALIDATE_SUPERVISOR_TOKEN = exports.GET_APPLICATION = exports.GET_USER_LOCATION = exports.QUERY_CHECK_USER_COUNTRY_IF_EMBARGOED = exports.MUTATE_UPGRADE_LEARNING_PATHWAY = exports.MUTATE_DEPROVISION_EXAM_CREDITS = exports.QUERY_APPRENTICE = exports.MUTATE_APPRENTICE = exports.MUTATE_EPA2L7_CASE_STATUS = exports.MUTATE_EPA2L4_CASE_STATUS = exports.QUERY_PERSON_LEVEL_EXEMPTIONS = exports.QUERY_QUALIFICATION_DATA = exports.QUERY_PERSON_LEVEL_EXEMPTION = exports.MUTATE_UPDATE_DOCUMENT_STATUS = exports.MUTATE_UPDATE_PERSON_LEVEL_EXEMPTION = exports.MUTATE_PERSON_EXAM_STATUS = exports.OPEN_PV_DASHBOARD = exports.MUTATE_PROMOCODE_TRIGGERED_EXEMPTION = exports.MUTATE_PERSON_EXAM_EXEMPTION = exports.QUERY_EXEMPTION_ENGINE = exports.MUTATE_QUALIFICATIONS = exports.MUTATE_LOWER_EXEMPTION = exports.MUTATE_PERSON_LEVEL_EXEMPTION = exports.GET_PERSON_LEVEL_EXEMPTION_UNIVERSITY_DETAILS = exports.GET_EXEMPTION_REFERENCE = exports.MUTATE_EXAM_CREDITS = exports.GET_EXAMINATIONS = exports.GET_EXISTING_CASE = exports.CREATE_SPECIALCONSIDERATION = exports.CREATE_CASE = exports.MUTATE_SECURITY_RESPONSE = exports.GET_EPA_BY_PERSON_ACCOUNT_ID = exports.GET_EPA_BY_EXTERNAL_VALIDATOR_ID = exports.QUERY_EXEMPTION_LEVEL_REFERENCE_BY_NAME = exports.QUERY_EXEMPTION_LEVEL_REFERENCE_BY_ID = exports.GET_SECURITY_QUESTION = exports.MUTATE_UPDATE_PERSON_ACCOUNT_STATUS = exports.MUTATE_PRIMARY_EMAIL = exports.MUTATE_FIRM_MEMBERSHIP_WITH_ATTESTATION = exports.MUTATE_PERSONAL_INFORMATION = exports.QUERY_PERSONAL_INFORMATION = exports.QUERY_ORGANIZATION_BY_ACCOUNT_ID = exports.QUERY_ORGANIZATION_BY_ACCOUNT_NUMBER = exports.UPDATE_ACCOUNT_UNIVERSITY_DETAILS = void 0;
exports.QUERY_GOLDEN_RECORD = `{
  getGoldenRecordByUserId {
    preferences,
    industryPreferences,
    trendPreferences,
    skillPreferences,
    shortcuts {
      topicSlug
      subtopicSlug
      categorySlug
      slicedAggsFilter
    }
  }
}`;
exports.QUERY_USER_STATE = `{
  getUserState
}`;
exports.MUTATE_USER_STATE = `
  mutation setUserState($valueMap: JSON!) {
    setUserState(valueMap: $valueMap)
  }
`;
exports.MUTATE_GOLDEN_RECORD_PREFERENCES = `
  mutation updateGoldenRecord($preferences: JSON) {
    updateGoldenRecord(preferences: $preferences) {
      preferences
    }
  }
`;
exports.MUTATE_GOLDEN_RECORD_CIMA_PREFERENCES = `
  mutation updateGoldenRecordForCimaPreferences($preferences: JSON, $industryPreferences: JSON, $trendPreferences: JSON, $skillPreferences: JSON) {
    updateGoldenRecordForCimaPreferences(preferences: $preferences, industryPreferences: $industryPreferences, trendPreferences: $trendPreferences, skillPreferences: $skillPreferences)
  }
`;
exports.MUTATE_GOLDEN_RECORD_SHORTCUTS = `
  mutation updateGoldenRecord($shortcuts: [ShortcutInput]) {
    updateGoldenRecord(shortcuts: $shortcuts) {
      shortcuts {
        topicSlug
        subtopicSlug
        categorySlug
        slicedAggsFilter
      }
    }
  }
`;
exports.MUTATE_GOLDEN_RECORD_EMAIL = `
  mutation updateGoldenRecord($email: String!) {
    updateGoldenRecord(email: $email) {
      name,
      email
    }
  }
`;
exports.QUERY_USER_BY_ID = `
 query getUserByAICPAIdAndLastName($id: Float!, $lastName: String!) {
    getUserByAICPAIdAndLastName(id: $id, lastName: $lastName)
  }
`;
exports.QUERY_USER_PROFILE = `{
  me {
    userId,
    lastName,
    firstName,
    roles,
    email,
    AICPAUID,
    clientAdminOf,
    firmBillingClientAdminOf,
    centersClientAdminOf
  }
}
`;
exports.QUERY_NET_FORUM_USER = `
{
  netforumProfile {
    firstName
    lastName
    email
    aicpauid
  }
}
`;
exports.QUERY_MARKETING_PREFERENCES = `
{
  getMarketingPreferences {
    isSubscribedToMarketing,
    thirdParty,
    contactViaEmail,
    contactViaPhone,
    contactViaPost
  }
}
`;
exports.MUTATE_MARKETING_PREFERENCES = `
  mutation updateMarketingPreferences($isSubscribedToMarketing: Boolean!, $thirdParty: Boolean!, $contactViaEmail: Boolean!, $contactViaPhone: Boolean!, $contactViaPost: Boolean!) {
    updateMarketingPreferences(isSubscribedToMarketing: $isSubscribedToMarketing, thirdParty: $thirdParty, contactViaEmail: $contactViaEmail, contactViaPhone: $contactViaPhone, contactViaPost: $contactViaPost) {
      isSubscribedToMarketing,
      thirdParty,
      contactViaEmail,
      contactViaPhone,
      contactViaPost
    }
  }
`;
exports.QUERY_USER_FEEDBACK_BY_CONTENT_ID = `
  query getUserFeedbackByContentId($contentId: ID!) {
    getUserFeedbackByContentId(contentId: $contentId) {
      feedback
    }
  }
`;
exports.MUTATE_USER_FEEDBACK_BY_CONTENT_ID = `
  mutation updateUserFeedbackByContentId($contentId: ID!, $feedback: JSON!) {
    updateUserFeedbackByContentId(contentId: $contentId, feedback: $feedback) {
      contentId,
      feedback
    }
  }
`;
exports.MUTATE_USER_FEEDBACK_BY_SURVEY = `
  mutation updateUserFeedbackBySurvey($survey: String!, $feedback: JSON!) {
    updateUserFeedbackBySurvey(survey: $survey, feedback: $feedback)
  }
`;
exports.GET_PUB_KEY = `
  {
    getPubKey
  }
`;
exports.CREATE_USER = `
  mutation ($user: NewUser!, $dependencies: RegistrationDependencies!) {
    createUser(user: $user, dependencies: $dependencies) {
      status,
      id,
      AICPAUID,
      personContactId
    }
  }
`;
exports.RESOLVE_EMAIL = `
  mutation resolveEmail($email: String!) {
    resolveEmail(email: $email)
  }
`;
exports.FORGOT_PASSWORD = `
  mutation forgotPassword($email: String!, $returnRecoveryTokenOnly: Boolean) {
    forgotPassword(email: $email, returnRecoveryTokenOnly: $returnRecoveryTokenOnly) {
      success
      recoveryToken
    }
  }
`;
exports.SEARCH_OKTA_USER = `
  {
    oktaUser
  }
`;
exports.GET_USER_PLATFORM = `
  query getUserPlatform($email: String!) {
    getUserPlatform(email: $email)
  }
`;
exports.CHANGE_PASSWORD = `
  mutation changePassword($oldPassword: String!, $newPassword: String!,) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      success
    }
  }
`;
exports.CHANGE_PASSWORD_NOTIFICATION_EMAIL = `
  mutation changePasswordEmailNotification($userDetails: UserDetails) {
    changePasswordEmailNotification(userDetails: $userDetails) {
      success
    }
  }
`;
exports.GENERATE_TEMPORARY_PASSWORD = `
  mutation generateTemporaryPassword($oktaId: String!) {
    generateTemporaryPassword(oktaId: $oktaId)
  }
`;
exports.QUERY_CPA_STATUS = `
{
  getCPAStatus {
    isLicensedCPA
  }
}
`;
exports.QUERY_MY_PROFILE = `
{
  getMyProfile
}
`;
exports.QUERY_SFMC_LINK = `
{
  getSFMCLink
}
`;
exports.MUTATE_CPA_STATUS = `
  mutation setCPAStatus($cpaFlag: Boolean!) {
    setCPAStatus(cpaFlag: $cpaFlag) {
      success,
      cpaFlag
    }
  }
`;
exports.MUTATE_TEMPORARY_PASSWORD_MAIL = `
  mutation sendTemporaryPasswordMail {
    sendTemporaryPasswordMail {
      success
    }
  }
`;
exports.MUTATE_UPDATED_PASSWORD_MAIL = `
  mutation sendUpdatedPasswordMail($oktaId: String!) {
    sendUpdatedPasswordMail(oktaId: $oktaId) {
      success
    }
  }
`;
exports.MUTATE_PERSON_ACCOUNT = `
  mutation updatePersonAccount($personAccountInfo: PersonAccount, $personAccountFlags: PersonAccountFlags) {
    updatePersonAccount(personAccountInfo: $personAccountInfo, personAccountFlags: $personAccountFlags)
  }
`;
exports.MUTATE_PROCESS_QUALIFICATION = `
  mutation processQualification($cpaLicenseInfo: [CPALicenseData], $applicationInfo: Application, $personAccountFlags: PersonAccountFlags) {
    processQualification(cpaLicenseInfo: $cpaLicenseInfo, applicationInfo: $applicationInfo, personAccountFlags: $personAccountFlags)
  }
`;
exports.MUTATE_EMPLOYMENT = `
  mutation processEmployment($employmentInfo: EmploymentInfo, $userProfileEmployerAddress: Address, $userProfileEmployerPhone: String, $isForEmploymentModal: Boolean, $isForCenterMembership: Boolean) {
    processEmployment(employmentInfo: $employmentInfo, userProfileEmployerAddress: $userProfileEmployerAddress, userProfileEmployerPhone: $userProfileEmployerPhone, isForEmploymentModal: $isForEmploymentModal, isForCenterMembership: $isForCenterMembership)
  }
`;
exports.MUTATE_UPDATE_EMPLOYMENT = `
  mutation updateEmployment($employmentInfo: EmploymentInfo) {
    updateEmployment(employmentInfo: $employmentInfo)
  }
`;
exports.MUTATE_UPDATE_EMPLOYMENT_DATA_SHARING = `
  mutation updateEmploymentDataSharing($employmentDataSharing: EmploymentDataSharing) {
    updateEmploymentDataSharing(employmentDataSharing: $employmentDataSharing)
  }
`;
exports.MUTATE_REMOVE_EMPLOYMENT = `
  mutation removeEmployment($id: String, $accountId: String) {
    removeEmployment(id: $id, accountId: $accountId)
  }
`;
exports.MUTATE_ORGANIZATION = `
  mutation updateOrganization($organizationId: String, $update: OrganizationUpdate) {
    updateOrganization(organizationId: $organizationId, update: $update)
  }
`;
exports.GET_APPLICATION_BY_ID = `
  query getCenterMembershipApplicationById($applicationId: String) {
    getCenterMembershipApplicationById(applicationId: $applicationId)
  }
`;
exports.QUERY_QUALIFICATION = `
  query getQualification($personAccountId: String) {
    getQualification(personAccountId: $personAccountId)
  }
`;
exports.QUERY_ORGANIZATION_BY_NAME_AND_ADDRESS = `
  query getOrganizationByNameAndAddressIfExists($accountName!: String, $address: ContactPointAddress) {
    getOrganizationByNameAndAddressIfExists(accountName: $accountName, address: $address)
  }

`;
exports.QUERY_MARKETING_CONSENT = `
{
  getMarketingData
}
`;
exports.MUTATE_UPDATE_MARKETING_CONSENT = `
  mutation updateMarketingData($marketingInfo: MarketingConsent) {
    updateMarketingData(marketingInfo: $marketingInfo)
  }
`;
exports.QUERY_ORGANIZATIONS_BY_NAME = `
  query searchOrganizationsByName($accountName: String, $isWildcard: Boolean, $returnAccountNameOnly: Boolean, $cityName: String, $isCityNameWildcard: Boolean, $returnCityOnly: Boolean, $isUniversity: Boolean, $zoomInfoSearch: Boolean, $tuitionProviderType: String, $zipCode: String, $isFromEmployment: Boolean ) {
    searchOrganizationsByName(accountName: $accountName, isWildcard: $isWildcard, returnAccountNameOnly: $returnAccountNameOnly, cityName: $cityName, isCityNameWildcard: $isCityNameWildcard, returnCityOnly: $returnCityOnly, isUniversity: $isUniversity, zoomInfoSearch: $zoomInfoSearch, tuitionProviderType: $tuitionProviderType, zipCode: $zipCode, isFromEmployment: $isFromEmployment)
  }
`;
exports.MUTATE_APPLICATION = `
  mutation processApplication($applicationInfo: Application){
    processApplication(applicationInfo: $applicationInfo)
  }
`;
exports.PROCESS_LEAVING_CREDENTIAL_APPLICATION_PAGE = `
  mutation processLeavingCredentialApplicationPage($applicationInfo: Application, $sfAccountId: String, $finraNumber: String, $enhancedMemberDirectoryConsent: Boolean){
    processLeavingCredentialApplicationPage(applicationInfo: $applicationInfo, sfAccountId: $sfAccountId, finraNumber: $finraNumber, enhancedMemberDirectoryConsent: $enhancedMemberDirectoryConsent)
  }
`;
exports.UPDATE_APPLICATION_CREDENTIALS = `
  mutation updateApplicationCredentials($applicationInfo: JSON){
    updateApplicationCredentials(applicationInfo: $applicationInfo)
  }
`;
exports.MUTATE_TLW = `
  mutation processTLW($tlwInfo: TLW){
    processTLW(tlwInfo: $tlwInfo)
  }
`;
exports.REMOVE_TLW = `
  mutation removeTLW($id: String){
    removeTLW(id: $id)
  }
`;
exports.MUTATE_SUPPRESSION = `
  mutation processSuppression($suppressionInfo: Suppression){
    processSuppression(suppressionInfo: $suppressionInfo)
  }
`;
exports.CREATE_EVENT_REGISTRATION = `
mutation createEventRegistration($eventRegistrationInfo: EventRegistration){
  createEventRegistration(eventRegistrationInfo: $eventRegistrationInfo)
}
`;
exports.UPDATE_ACCOUNT_UNIVERSITY_DETAILS = `
  mutation updateAccountUniversityDetails($id: String, $yearOfGraduation: String, $conditionalExemptionStudent: Boolean){
    updateAccountUniversityDetails(id: $id, yearOfGraduation: $yearOfGraduation, conditionalExemptionStudent: $conditionalExemptionStudent)
  }
`;
exports.QUERY_ORGANIZATION_BY_ACCOUNT_NUMBER = `
  query getOrganizationByAccountNumberOrAccountId($accountNumber: String) {
    getOrganizationByAccountNumberOrAccountId(accountNumber: $accountNumber)
  }
`;
exports.QUERY_ORGANIZATION_BY_ACCOUNT_ID = `
  query getOrganizationByAccountNumberOrAccountId($accountId: String) {
    getOrganizationByAccountNumberOrAccountId(accountId: $accountId)
  }
`;
/**
 * Might need to use by MART-55, will remove if not needed
 *
 */
exports.QUERY_PERSONAL_INFORMATION = `
  query getPersonalInformation($aicpaId: String, $email: String!, $personAccountId: String) {
    getCustomerData(aicpaId: $aicpaId, email: $email)
    getQualification(personAccountId: $personAccountId)
  }
`;
exports.MUTATE_PERSONAL_INFORMATION = `
  mutation updatePersonalInformation($personAccountInfo: PersonAccount, $cpaLicenseInfo: [CPALicenseData], $applicationInfo: Application, $personAccountFlags: PersonAccountFlags) {
    updatePersonAccount(personAccountInfo: $personAccountInfo, personAccountFlags: $personAccountFlags)
    processQualification(cpaLicenseInfo: $cpaLicenseInfo, applicationInfo: $applicationInfo, personAccountFlags: $personAccountFlags)
  }
`;
exports.MUTATE_FIRM_MEMBERSHIP_WITH_ATTESTATION = `
  mutation createFirmMembershipWithAttestation($partnerAccountId: String, $organizationAccountId: String, $relationshipType: String, $adminType: String, $adminAccountDetail: AdminAccountDetailPayload, $attestationTexts: [String], $applicationProgress: String, $tierSku: String, $hearAboutUsMembershipQuestion: String) {
    createFirmMembershipWithAttestation(partnerAccountId: $partnerAccountId, organizationAccountId: $organizationAccountId, relationshipType: $relationshipType, adminType: $adminType, adminAccountDetail: $adminAccountDetail, attestationTexts: $attestationTexts, applicationProgress: $applicationProgress, tierSku: $tierSku, hearAboutUsMembershipQuestion: $hearAboutUsMembershipQuestion)
  }
`;
exports.MUTATE_PRIMARY_EMAIL = `
  mutation updatePrimaryEmail($emailAddress: String!, $emailType: String) {
    updatePrimaryEmail(emailAddress: $emailAddress, emailType: $emailType)
  }
`;
exports.MUTATE_UPDATE_PERSON_ACCOUNT_STATUS = `
mutation updateAccountPersonAccountStatus($id: String $personAccountId: String) {
  updateAccountPersonAccountStatus(id: $id, personAccountId: $personAccountId)
}`;
exports.GET_SECURITY_QUESTION = `
  {
    getSecurityQuestion
  }
`;
exports.QUERY_EXEMPTION_LEVEL_REFERENCE_BY_ID = `
  query getExemptionLevelReferenceById($id: String, $learningPathway:String, $entrypointLevel:String) {
    getExemptionLevelReferenceById(id: $id, learningPathway: $learningPathway,entrypointLevel: $entrypointLevel)
  }
`;
exports.QUERY_EXEMPTION_LEVEL_REFERENCE_BY_NAME = `
  query getExemptionLevelReferenceByName($name: String) {
    getExemptionLevelReferenceByName(name: $name)
  }
`;
exports.GET_EPA_BY_EXTERNAL_VALIDATOR_ID = `
  query getEPAByExternalValidatorId($externalValidatorId: String) {
    getEPAByExternalValidatorId(externalValidatorId: $externalValidatorId)
  }
`;
exports.GET_EPA_BY_PERSON_ACCOUNT_ID = `
  query getEPAByPersonAccountId($personAccountId: String) {
    getEPAByPersonAccountId(personAccountId: $personAccountId)
  }
`;
// test
exports.MUTATE_SECURITY_RESPONSE = `
  mutation updateSecurityResponse($securityQuestion: SecurityQuestion) {
    updateSecurityResponse(securityQuestion: $securityQuestion)
  }
  `;
exports.CREATE_CASE = `
  mutation createCase($caseInfo: CaseInformation) {
    createCase(caseInfo: $caseInfo)
  }`;
exports.CREATE_SPECIALCONSIDERATION = `
  mutation createSpecialConsideration($specialConsiderationInfo: SpecialConsiderationInformation) {
    createSpecialConsideration(specialConsiderationInfo: $specialConsiderationInfo)
  }`;
exports.GET_EXISTING_CASE = `
query getExistingCaseByEmail($email: String) {
  getExistingCaseByEmail(email: $email)
}
`;
exports.GET_EXAMINATIONS = `
  query getExaminations {
    getExaminations
  }`;
exports.MUTATE_EXAM_CREDITS = `
  mutation processExamCredits($examCreditsInfo: ExamCredits){
    processExamCredits(examCreditsInfo: $examCreditsInfo)
  }
`;
exports.GET_EXEMPTION_REFERENCE = `
  query getExemption($type: String, $addedParams: GetExemptionParams) {
    getExemption(type: $type, addedParams: $addedParams)
  }
`;
exports.GET_PERSON_LEVEL_EXEMPTION_UNIVERSITY_DETAILS = `
  query getPersonLevelExemptionUniversityDetails($personAccountId: String) {
    getPersonLevelExemptionUniversityDetails(personAccountId: $personAccountId)
  }
`;
exports.MUTATE_PERSON_LEVEL_EXEMPTION = `
  mutation createPersonLevelExemption($personAccountId: String, $professionalQualificationData: [ProfessionalQualificationInfo], $educationalQualificationData: [EducationalQualificationInfo], $workExperienceData: [WorkExperienceInfo], $learningPathway: String) {
    createPersonLevelExemption(personAccountId: $personAccountId, professionalQualificationData: $professionalQualificationData, educationalQualificationData: $educationalQualificationData, workExperienceData: $workExperienceData, learningPathway: $learningPathway){
      id
      success
      errors
    }
  }
`;
exports.MUTATE_LOWER_EXEMPTION = `
  mutation updateLowerExemption($exemptionLevelKey: String) {
    updateLowerExemption(exemptionLevelKey: $exemptionLevelKey){id
      success
      errors
    }
  }
`;
exports.MUTATE_QUALIFICATIONS = `
  mutation saveQualifications($personAccountId: String, $professionalQualificationData: [ProfessionalQualificationInfo], $educationalQualificationData: [EducationalQualificationInfo], $recordType: String) {
    saveQualifications(personAccountId: $personAccountId, professionalQualificationData: $professionalQualificationData, educationalQualificationData: $educationalQualificationData, recordType: $recordType){
      id
      success
      errors
    }
  }
`;
exports.QUERY_EXEMPTION_ENGINE = `
  query exemptionEngine($id: String, $learningPathway:String, $isAicpaRegular: Boolean, $flpSwitchUpgrade: Boolean, $entrypointLevel:String) {
    exemptionEngine(id: $id, learningPathway: $learningPathway, isAicpaRegular: $isAicpaRegular, flpSwitchUpgrade: $flpSwitchUpgrade, entrypointLevel: $entrypointLevel)
  }
`;
exports.MUTATE_PERSON_EXAM_EXEMPTION = `
  mutation createPersonExamExemption($createPersonExamExemption: [PersonExamInfo], $learningPathway: String, $nonMember:Boolean) {
    createPersonExamExemption(createPersonExamExemption: $createPersonExamExemption,learningPathway: $learningPathway, nonMember: $nonMember){
      id
      success
      errors
    }
  }
`;
exports.MUTATE_PROMOCODE_TRIGGERED_EXEMPTION = `
  mutation createPromoCodeTriggeredExemption(
    $personAccountId: String,
    $promoCode: String,
    $giveawayExemption: [String],
    $takeawayExemption: [String],
    $pathway: String,
  ) {
    createPromoCodeTriggeredExemption(personAccountId: $personAccountId, promoCode: $promoCode, giveawayExemption: $giveawayExemption, takeawayExemption: $takeawayExemption, pathway: $pathway)
  }
`;
exports.OPEN_PV_DASHBOARD = `
  query getPVSession($actionType: String!, $registrationId: String) {
    getPVSession(actionType: $actionType, registrationId: $registrationId)
  }
`;
exports.MUTATE_PERSON_EXAM_STATUS = `
  mutation personExamStatus($personExamStatus: PersonExamStatusParams) {
    personExamStatus(personExamStatus: $personExamStatus){
      id
      success
      errors
    }
  }`;
exports.MUTATE_UPDATE_PERSON_LEVEL_EXEMPTION = `
  mutation updatePersonLevelExemption($personLevelExemption: PersonLevelExemption) {
    updatePersonLevelExemption(personLevelExemption: $personLevelExemption)
  }
`;
exports.MUTATE_UPDATE_DOCUMENT_STATUS = `
  mutation updateDocumentStatus($documentStatus: PersonDocumentStatus) {
    updateDocumentStatus(documentStatus: $documentStatus)
  }
`;
exports.QUERY_PERSON_LEVEL_EXEMPTION = `
  query getPersonLevelExemptionId($accountId: String) {
    getPersonLevelExemptionId(accountId: $accountId)
  }
`;
exports.QUERY_QUALIFICATION_DATA = `
  query getQualificationDataById($accountId: String, $recordType: String) {
    getQualificationDataById(accountId: $accountId, recordType: $recordType)
  }
`;
exports.QUERY_PERSON_LEVEL_EXEMPTIONS = `
  query getPersonLevelExemptions($accountId: String) {
    getPersonLevelExemptions(accountId: $accountId)
  }
`;
exports.MUTATE_EPA2L4_CASE_STATUS = `
mutation updateEPA2L4CaseStatus($Id: String, $Status: String, $sku: String, $SubmissionDate: String ) {
    updateEPA2L4CaseStatus(Id: $Id, Status: $Status, sku: $sku, SFS_CAS_DateofEPASubmission__c: $SubmissionDate)
  }
`;
exports.MUTATE_EPA2L7_CASE_STATUS = `
  mutation updateEPA2L7CaseStatus($Id: String, $Status: String, $SubmissionDate: String, $sku: String) {
    updateEPA2L7CaseStatus(Id: $Id, Status: $Status, SFS_CAS_DateofEPASubmission__c: $SubmissionDate, sku: $sku)
  }
`;
exports.MUTATE_APPRENTICE = `
  mutation createApprenticePathway($accountId: String, $apprenticePathway: String) {
    createApprenticePathway(accountId: $accountId, apprenticePathway: $apprenticePathway)
  }
`;
exports.QUERY_APPRENTICE = `
  query getApprenticePathway($accountId: String) {
    getApprenticePathway(accountId: $accountId)
  }
`;
exports.MUTATE_DEPROVISION_EXAM_CREDITS = `
  mutation deprovisionExamCredits($props: DeprovisionExamCreditsOnPathwaySwitchDetails) {
    deprovisionExamCredits(props: $props)
  }
`;
exports.MUTATE_UPGRADE_LEARNING_PATHWAY = `
  mutation upgradeLearningPathway($upgradeLearningPathwayDetails: UpgradeLearningPathwayDetails) {
    upgradeLearningPathway(upgradeLearningPathwayDetails: $upgradeLearningPathwayDetails)
}
`;
exports.QUERY_CHECK_USER_COUNTRY_IF_EMBARGOED = `
  query checkUserCountryIfEmbargoed($userCountry: String) {
    checkUserCountryIfEmbargoed(userCountry: $userCountry) {
      embargoed
    }
  }`;
exports.GET_USER_LOCATION = `
  {
    getUserLocation {
      country
    }
  }
`;
exports.GET_APPLICATION = `
  query getApplications($id: String, $personAccountId: String, $status: String){
    getApplications(id: $id, personAccountId: $personAccountId, status: $status)
  }
`;
exports.VALIDATE_SUPERVISOR_TOKEN = `
  query validateSupervisorToken($token: String) {
    validateSupervisorToken(token: $token)
  }
`;
exports.MUTATE_CURRENT_LEARNING_PATHWAY = `
  mutation updateLearningPathwayApplication( $learningPathway: String, $personAccountId: String, $applicationId: String){
    updateLearningPathwayApplication(learningPathway: $learningPathway, personAccountId: $personAccountId, applicationId: $applicationId)
  }
`;
exports.GET_USER_SYLLABUS = `
  query getSyllabusByPersonAccountId($sfId: String) {
    getSyllabusByPersonAccountId(sfId: $sfId)
  }
`;
exports.SEARCH_EMPLOYER = `
  query searchEmployer($employerDetails: EmployerDetails) {
    searchEmployer(employerDetails: $employerDetails)
  }
`;
//# sourceMappingURL=user-queries.js.map